export default "/images/menu-ico4.png?7a5a0bf04ed2844da32bf5dc37152155";